<template>
  <div class="preregistration-details">

    <h2>{{ $t('title.' + action + '-prereg') }}</h2>

    <el-row :gutter="40">
      <el-col :xs="24" :sm="24" :md="24" :lg="12">

        <data-form
          :entity="headData"
          :fields="headDataFields"
          hide-buttons
          @change="d => headData = d"
        />

      </el-col>
    </el-row>

    <el-row :gutter="40">

      <el-col :xs="24" :sm="24" :md="24" :lg="12" v-for="i in 2">

        <el-row v-for="(swics, index) in switches" v-if="swics.index % 2 == i - 1" :key="index" >

          <el-col :xs="24" :sm="24" :md="24" :lg="24">

            <h3>{{ swics.name }}</h3>

            <access-form
              :access="getAccessForSwitch(swics)"
              :buttons="[]"
              :hideUserLevel="true"
              :disabled="!!getAccessForSwitch(swics).pending_access_id"
              showRegStatus
              @change="(formModel) => onChange(formModel, swics)"
            />

          </el-col>

        </el-row>

      </el-col>

    </el-row>

    <div class="button-row">

      <el-button
        type="primary"
        @click="onSubmit(true)">{{ $t('button.save-scheduled') }}</el-button>

      <el-button
        type="warning"
        @click="onSubmit(false)">{{ $t('button.send') }}</el-button>

      <el-button
        type="default"
        @click="onCancel()">{{ $t('button.cancel') }}</el-button>

    </div>

  </div>
</template>

<script>
import { post } from 'providers/http'
import findAll from 'service/findAll'
import findOne from 'service/findOne'

import AccessForm from 'components/access/AccessForm'

import userLevels from 'components/access/userLevels'

export default {
  name: 'preregistration-details',
  props: {
  },
  data () {
    return {
      headData: {
        contact_name: '',
        userLevel: 1
      },
      headDataFields: {
        'contact_name': {
          type: 'text',
          rules: [{ required: true, type: 'string' }]
        },
        'userLevel': {
          type: 'select',
          options: userLevels,
          rules: [{ required: true, type: 'number' }]
        }
      },
      accesses: {}
    }
  },
  computed: {
    action () {
      return this.preregistration.id ? 'edit' : 'create'
    },
    preregId () {
      return this.$route.params.preregId
    },
    controllerId () {
      return this.$route.params.controllerId || this.preregistration.controller_id
    }
  },
  methods: {
    onChange (formModel, { id }) {
      this.accesses[id] = formModel
    },
    async onSubmit (scheduled) {
      const id = this.preregId || 'new'

      const controllerId = this.controllerId

      const accesses = Object.entries(this.accesses).map(([ swicsId, formModel ]) => ({
        ...formModel,
        switch_id: swicsId
      }))

      if (!accesses.find(a => a.registration_status !== 'none')) {
        return this.showWarning('warning.no-access')
      }

      const data = {
        controllerId,
        accesses,
        ...this.headData,
        scheduled
      }

      try {
        await post(`api/v1/preregistrations/${id}`, data)

        this.showSuccess('prereg-saved')

        this.$router.back()
      }
      catch (err) {
        console.error(err)
      }
    },
    onCancel () {
      this.$router.back()
    },
    getAccessForSwitch ({ id: switch_id }) {
      if (!this.preregistration.mobileAccesses) {
        return {}
      }

      const match = this.preregistration.mobileAccesses.find(a => a.switch_id === switch_id)

      return { ...match }
    }
  },
  watch: {
    preregistration: {
      immediate: true,
      handler ({ contact_name, userLevel = 1 }) {
        this.headData = {
          contact_name,
          userLevel
        }
      }
    }
  },
  components: { AccessForm },
  mixins: [
    findOne('preregistrations', 'preregistration', function () { return this.preregId }),
    findAll('switches', {
      filter (s) { return s.controller_id === this.controllerId }
    }),
    findAll('controllers')
  ]
}
</script>

<style lang="scss">
.preregistration-details {
  .button-row {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// PreregistrationDetails.vue?0359af7c